import {
    plusIcon,
    searchIcon,
    tickBoxIcon,
    formIcon,
    emptyIcon,
    productsIcon,
} from '../assets/factory-icons';

export const factoryCards = [
    {
        id: 1,
        label: 'Ürün Ekle',
        icon: plusIcon,
        navPath: 'add-product',
        isNavCard: true,
    },
    {
        id: 2,
        label: 'Ürünler',
        icon: productsIcon,
        navPath: 'products',
        isNavCard: true,
    },
    {
        id: 3,
        label: 'İş Emri Takip Formu',
        icon: tickBoxIcon,
        navPath: 'work-order',
        isNavCard: true,
    },
    {
        id: 4,
        label: 'Emaye Boyama İş Emri Takip Formu',
        icon: formIcon,
        navPath: 'enamel-painting-work-order',
        isNavCard: true,
    },
    {
        id: 5,
        label: 'Form Takip Sayfası',
        icon: searchIcon,
        navPath: 'form-tracking',
        isNavCard: true,
    },
    {
        id: 6,
        label: 'Çıkış Yap',
        icon: emptyIcon,
        navPath: '/',
        isNavCard: false,
    },
];
